import 'mapbox-gl/dist/mapbox-gl.css';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mapbox/mr-ui/icon';
import { getToken } from '../utils/get-token';
import { getTypes } from '../utils/get-types';
import { ActionCreators } from '../redux/action-creators';
import fetch from 'node-fetch';

class MapActions extends React.PureComponent {
  constructor(props) {
    super(props);
    this.queryMap = this.queryMap.bind(this);
    this.state = {
      added: false
    };

    this.addFeature = this.addFeature.bind(this);
  }

  async queryMap() {
    const { map } = this.props;
    const { lng, lat } = map.getCenter();
    const zoom = map.getZoom();
    const request = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${getToken()}&language=en-US&types=${getTypes(
      zoom
    )}`;
    const result = await fetch(request).then(res => res.json());

    const queryResult = {
      text: result.features.length ? result.features[0].text : 'Untitled',
      center: result.features.length ? result.features[0].center : [0, 0]
    };

    if (this.state.added) {
      window.setTimeout(() => {
        this.setState({ added: false }, () => {
          ActionCreators.setMapResult(queryResult, zoom);
        });
      }, 3000);
    } else {
      ActionCreators.setMapResult(queryResult, zoom);
    }
  }

  addFeature() {
    this.setState({ added: true }, () => {
      ActionCreators.addFeature();
    });
  }

  componentDidMount() {
    const { map } = this.props;
    this.queryMap();
    map.on('moveend', this.queryMap);
  }

  render() {
    const { added } = this.state;
    const { mapResult } = this.props;
    let button = (
      <button
        test="add-feature"
        onClick={this.addFeature}
        className="btn px12 txt-s"
      >
        Add place
      </button>
    );

    if (added) {
      button = (
        <button disabled={true} className="btn px12 txt-s">
          <Icon name="check" inline={true} />
          <span className="ml3">Added</span>
        </button>
      );
    }

    return (
      <div className="absolute bottom z5 w-full mb60 events-none">
        <div className="flex-parent flex-parent--center-main mx12">
          <div className="flex-child flex-parent flex-parent--center-cross round-full px12 py12 bg-white shadow-darken10 events-all">
            <Icon name="marker" inline={true} />
            <span test="queryText" className="mr18 ml3 wmax300 txt-truncate">
              {mapResult && mapResult.geocode
                ? mapResult.geocode.text
                : 'Untitled'}
            </span>
            {button}
          </div>
        </div>
      </div>
    );
  }
}

MapActions.propTypes = {
  mapResult: PropTypes.object,
  map: PropTypes.object.isRequired
};

export { MapActions };
